import { Box, Button, Modal, ModalProps, Stack, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { IconButton, Icons } from 'utoniq-ui'

import { ArtistPostVideoFragment } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'

import { ShortVideoContent } from './ShortVideoContent'
type ShortVideoModalProps = Pick<ModalProps, 'open'> & {
  open: boolean
  onClose: () => void
  posts: ArtistPostVideoFragment[]
  isMembershipPersonalInformationRequired: boolean
  onFetchMore: () => void
  postIndex: number
  onLike: (postId: string, isLike: boolean, likeCount: number) => Promise<void>
  onReportArtist?: (
    postId: string,
    artistId: string,
    accountId: string
  ) => Promise<void>
  onBlockUser: (id: string) => Promise<void | boolean>
  responsive?: boolean
}

export const ShortVideoModal = ({
  open,
  onClose,
  posts,
  isMembershipPersonalInformationRequired,
  onFetchMore,
  postIndex,
  onReportArtist,
  onBlockUser,
  onLike,
  responsive = false,
}: ShortVideoModalProps) => {
  const { zIndex } = useTheme()
  // NOTE Safariでオーディオトラック付きの動画のときにミュートでないと自動再生されない仕様のための対処
  const { t } = useTranslation('artistPostVideos')
  const [muted, setMuted] = useState(false)
  const maxWidth = responsive ? '100vw' : '600px'
  return (
    <Modal open={open} onClose={onClose} disablePortal>
      <Box
        sx={{
          width: '100%',
          // NOTE BaseLayoutの横幅指定に準拠
          maxWidth: maxWidth,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'black',
          outline: 'none',
        }}
      >
        <Stack
          direction="row"
          sx={{
            position: 'absolute',
            width: '100%',
            height: '64px',
            p: '8px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <IconButton.Back
            size="medium"
            onClick={onClose}
            color="white"
            sx={{
              zIndex: zIndex.modal + 2,
              '&::before': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '48px',
                height: '48px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '50%',
                transform: 'translate(-50%, -50%)',
              },
            }}
          />
          {muted && (
            <Button
              variant="text"
              size="medium"
              sx={{
                zIndex: zIndex.modal + 2,
                color: 'white',
                bgcolor: 'rgba(0, 0, 0, 0.5)',
                height: '100%',
                fontSize: '1rem',
                px: '16px',
                py: '6px',
              }}
              onClick={() => {
                setMuted(false)
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {t('unmute')}
                <Icons.AudioOff
                  color="white"
                  sx={{ height: '24px', width: '24px' }}
                />
              </Box>
            </Button>
          )}
        </Stack>
        <ShortVideoContent
          initialIndex={postIndex}
          posts={posts}
          isMembershipPersonalInformationRequired={
            isMembershipPersonalInformationRequired
          }
          defaultMute={() => setMuted(true)}
          onFetchMore={onFetchMore}
          onLike={onLike}
          onReportArtist={onReportArtist}
          onBlockUser={onBlockUser}
          onClose={onClose}
          muted={muted}
          maxWidth={responsive ? maxWidth : undefined}
        />
      </Box>
    </Modal>
  )
}
